// extracted by mini-css-extract-plugin
export default {"slot":"mobile-preview-toggle_slot__TV487","toggle":"mobile-preview-toggle_toggle__oG8ut"};